import { PaddingMode } from '../padding';

/**
 * Zero padding.
 */
export const ZERO_PADDING: PaddingMode = 'zero';

/**
 * Returns a single value of zero padding.
 * 
 * @return         Single padding value.
 */
export function zeroPadding(): number {
  return 0;
};
